import { CustomBuydownTermRate } from '@src/types/CustomBuydown'

// Applies the merchant's Custom Buydown rate rebate to the base (no-rebate) per-term rates for
// display. Mirrors the backend BuyDownRateCalculator, which subtracts the rebate from the annual
// rate and floors it at 0. The rebate is never frozen onto the plan — its single source of truth
// is Merchant.FlashPlanRateRebate — so it is applied here at display time.
export const applyRebateToTermRates = (rates: CustomBuydownTermRate[], rebate: number): CustomBuydownTermRate[] =>
  rates.map((rate) => ({
    ...rate,
    promoRate: Math.max(0, rate.promoRate - rebate),
    regularRate: Math.max(0, rate.regularRate - rebate),
  }))